import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/landing.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isQuizPage = location.pathname.startsWith('/quiz');
  const [userEmail, setUserEmail] = useState('');
  const [userVerified, setUserVerified] = useState(false);
  const [displayEmail, setDisplayEmail] = useState('');
  
  // Load user data on component mount and whenever localStorage changes
  useEffect(() => {
    const email = localStorage.getItem('userEmail');
    const verified = localStorage.getItem('userVerified') === 'true';
    
    setUserEmail(email || '');
    setUserVerified(verified);
    
    // Create truncated display version of email
    if (email) {
        setDisplayEmail(email.substring(0, 6) + '...');
    } else {
      setDisplayEmail('');
    }
  }, [location.pathname]); // Re-run when route changes to catch login/logout events

  const handleLogout = () => {
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userVerified');
    setUserEmail('');
    setUserVerified(false);
    setDisplayEmail('');
    window.location.reload(); // Refresh to show auth component
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="nav">
          <Link to="/" className="logo">Prep<span>Letter</span></Link>
          <button className="hamburger-menu" onClick={toggleMobileMenu} aria-label="Toggle navigation">
            <i className={isMobileMenuOpen ? 'bi bi-x-lg' : 'bi bi-list'}></i>
          </button>
          <ul className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
            {userEmail && userVerified ? (
              // LOGGED IN: show Quizzes, Survey, Settings, Logout
              <>
                <li>
                  <Link 
                    to="/prepletters" 
                    onClick={toggleMobileMenu}
                    className="premium-link"
                  >
                    📚 PrepLetters
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/quizzes" 
                    onClick={toggleMobileMenu} 
                    className={isQuizPage ? 'active' : ''}
                  >
                    Quizzes
                  </Link>
                </li>
                <li><Link to="/survey" onClick={toggleMobileMenu}>How're we doing?</Link></li>
                <li><Link to="/settings" onClick={toggleMobileMenu}>Settings</Link></li>
                <li className="user-info">
                  <div className="user-avatar">
                    <span>{userEmail.charAt(0).toUpperCase()}</span>
                  </div>
                  <span className="user-email">{displayEmail}</span>
                  <button 
                    className="logout-btn" 
                    onClick={handleLogout}
                    title="Logout"
                  >
                    <i className="bi bi-box-arrow-right"></i>
                  </button>
                </li>
              </>
            ) : (
              // LOGGED OUT: show Home, Learn, Demo, Features, Login
              <>
                <li><Link to="/" onClick={toggleMobileMenu}>Home</Link></li>
                <li><Link to="/learn" onClick={toggleMobileMenu}>Learn</Link></li>
                <li><a href="#demo" onClick={toggleMobileMenu}>Demo</a></li>
                <li><a href="#features" onClick={toggleMobileMenu}>Features</a></li>
                <li className="login-nav-item">
                  <button 
                    className="login-btn" 
                    onClick={() => navigate('/login')}
                    title="Login"
                  >
                    <i className="bi bi-box-arrow-in-right"></i>
                    <span>Login</span>
                  </button>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
